import React, { createContext, useCallback, useContext } from "react";
import { Bounce, toast, ToastContainer, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastsContextInterface {
  showToast: (
    id: string,
    content: React.ReactNode,
    title?: React.ReactNode,
    variant?: "success" | "info" | "warning" | "error"
  ) => void;
  removeToast: (id: string) => void;
}

const ToastsContext = createContext<ToastsContextInterface>({} as ToastsContextInterface);

export const ToastsProvider = ({ children }: React.PropsWithChildren) => {
  const showToast = useCallback(
    (
      id: string,
      content: React.ReactNode,
      title: React.ReactNode,
      variant: "success" | "info" | "warning" | "error" = "info"
    ) => {
      const options: ToastOptions = {
        toastId: id,
        type: variant,
        position: "bottom-right",
        theme: "light",
        autoClose: 3000,
        hideProgressBar: false,
        progress: undefined,
        closeOnClick: true,
        transition: Bounce,
        pauseOnHover: true,
        draggable: true,
      };
      toast(
        <div>
          {title && <div style={{ fontWeight: "bold", marginBottom: 4 }}>{title}</div>}
          <div>{content}</div>
        </div>,
        options
      );
    },
    []
  );

  const removeToast = useCallback((id: string) => {
    toast.dismiss(id);
  }, []);

  return (
    <ToastsContext.Provider value={{ showToast, removeToast }}>
      {children}
      <ToastContainer />
    </ToastsContext.Provider>
  );
};

export const useToasts = () => useContext(ToastsContext);
